<template>
  <div class="socket-amount">
    <div class="accumulative-total">
      <!-- 文字滚动 -->
      <div class="accumulative-total-item">
        <div class="total-title">
          平台监控资源
        </div>
        <div class="tip-text">
          （云主机数 + k8s节点数 + rds实例数 + redis实例数 + es实例数 + slb数 + pod数）
        </div>
        <flip-cards :isRefresh="isRefresh" :num="totalCount" />
      </div>
    </div>
    <div class="today-station">
      <div class="row-item" v-for="(item, index) in data" :key="index">
        <template>
          <div>
            <div class="name">
              {{ item.name }}
            </div>
            <div class="show-item">
              <countTo
                v-if="index == 4"
                :startVal="0"
                :endVal="item.number||0"
                :duration="2000"
                :decimals="
                  item.number.toString().split('.')[1]
                    ? item.number.toString().split('.')[1].length
                    : 0
                "
                suffix="%"
                :key="componentKey1"
              ></countTo>
              <countTo
                v-else
                :startVal="0"
                :endVal="item.number||0"
                :duration="2000"
                :key="componentKey"
              ></countTo>
              <!-- {{ item.number }} -->
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import countTo from 'vue-count-to';
import FlipCards from './flip-cards.vue';

export default {
  components: {
    FlipCards,
    countTo,
  },
  props: {
    // 资源总数
    totalCount: {
      type: Number,
      default: 0,
    },
    data: {
      type: Array,
      default: () => [],
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      componentKey1: 0,
      componentKey: 0,
      // 健康数据
      // stationData: [
      //   {
      //     name: 'PV',
      //     number: 0,
      //   },
      //   {
      //     name: 'UV',
      //     number: 0,
      //   },
      //   {
      //     name: '接口请求数',
      //     number: 0,
      //   },
      //   {
      //     name: '接口错误数',
      //     number: 0,
      //   },
      //   {
      //     name: '接口错误率',
      //     // number: `${0}%`,
      //     number: 0,
      //   },
      // ],
    };
  },
  watch: {
    isRefresh() {
      if (this.isRefresh) {
        this.forceRerender();
      }
      this.$emit('handleFinishRefresh');
    },
  },
  methods: {
    forceRerender() {
      if (this.isRefresh) {
        this.componentKey += 1;
        this.componentKey1 += 1;
      }
    },
    // 格式化健康数据
    // getHealthData() {
    //   this.stationData = [];
    //   Object.keys(this.data).forEach((item) => {
    //     if (item === 'pv') {
    //       this.stationData.push({ name: 'PV', number: this.data[item] });
    //     } else if (item === 'uv') {
    //       this.stationData.push({ name: 'UV', number: this.data[item] });
    //     } else if (item === 'apiRequest') {
    //       this.stationData.push({ name: '接口请求数', number: this.data[item] });
    //     } else if (item === 'apiError') {
    //       this.stationData.push({ name: '接口错误数', number: this.data[item] });
    //     } else {
    //       this.stationData.push({ name: '接口错误率', number: this.data[item] });
    //     }
    //   });
    // },
  },
};
</script>
<style lang="scss">
.socket-amount {
  min-width: 924px;
  height: 273px;
  padding: 0px 59px;
  margin: 0 10px;
  box-sizing: border-box;
  background-image: url("../../../assets/screen-adapter/背景框-中部.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .accumulative-total {
    padding: 20px 30;
    .accumulative-total-item {
      width: 100%;
      height: 156px;
      padding: 0 9px;
      background-image: url("../../../assets/screen-adapter/背景-本月累计销售额.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .total-title {
        padding-top: 11px;
        margin-bottom: 4px;
        font-size: 34px;
        line-height: 34px;
        font-weight: bold;
        color: #66ffff;
        margin-top: 20px;
        text-align: center;
      }
      .tip-text {
        margin-bottom: 13px;
        font-size: 14px;
        font-weight: bold;
        color: #66ffff;
        text-align: center;
      }
    }
  }
  .today-station {
    padding: 11px 0;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    .row-item {
      width: 154px;
      height: 76px;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      // background: linear-gradient(180deg, #3D7FFF 0%, #1C2F5F 100%);
      background-image: url("../../../assets/screen-adapter/card-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 6px;
      &:nth-child(5) {
        margin-right: 0;
      }
      .name {
        padding-left: 5px;
        font-size: 18px;
        font-weight: bold;
        color: #1acfd7;
      }
      .show-item {
        margin-top: 7px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
}
</style>
